// extracted by mini-css-extract-plugin
export default {"card":"Card_card__q-Nyr","yellow":"Card_yellow__GVMdg","red":"Card_red__4+gFw","head":"Card_head__DK3ZD","title":"Card_title__uxDO4","closeBtn":"Card_closeBtn__jBzZt"};